<template>
    <div class="container-fluid mt-2">
      <div class="form-group">
        <label>ID</label>
        <input type="text" class="form-control" v-model="item.attributes.id.value"/>
      </div>
      <div class="form-group">
        <label>Bedingung</label>
        <input type="text" class="form-control" v-model="cond" @blur="updateCond"/>
      </div>
    </div>
  <!-- <conditionExpression xsi:type="tFormalExpression"><![CDATA[1==1]]></conditionExpression> -->
</template>

<script>
import xmlutils from '@/modules/xmlutil.js'
import bpmn from '@/modules/bpmn.js'

export default {
  props: ["item"],
  data() {
    return {
        cond: ''
    }
  },
  watch: {
    item: function() {
      this.cond = '';
      this.parseItem();
    }
  },
  created() {
    console.log('edge created',this.item);
    this.parseItem();
  },
  methods: {
    parseItem() {
      var condchild = xmlutils.jsonxmlchild(this.item,'conditionExpression');
      if (condchild && condchild.children && condchild.children.length > 0) {
        console.log('condition found:',condchild.children[0]);
        this.cond = condchild.children[0].content.substring(2,condchild.children[0].content.length-1);
      }
    },
    updateCond() {
      console.log('uc1',this.item);
      if (!this.item.children) {
        this.item.children = [];
      }
      var condchild = xmlutils.jsonxmlchild(this.item,'conditionExpression');
      console.log('uc2',condchild);
      if (!this.cond || this.cond === '') {
        this.item.children = [];
      } else {
        if (!condchild) {
          condchild = bpmn.newConditionExpression();
          this.item.children.push(condchild);
        } else  if (!condchild.children) {
          condchild.children = [{"type":4,"content":''}];
        }
        console.log('update condition',this.cond,condchild);
        condchild.children[0].content = '${' + this.cond + '}';
      }
    }
  }
}
</script>
